import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import { EmptyLoadingPage } from '../components/common/presentation';
import { configApi, IdleTimeout, loadConfig, orangeThemeLight, SuccessContext, Toast, toastStatus } from '../core';
import { LegacyAuthContext } from '../core/auth/legacy-auth-context';
import { NetworkStatus } from './network-status';

loadConfig(import.meta.env.VITE_CONFIG);

export function AppContext({ children, onAuthorized, onSignOut, idleTimeout }) {
  const config = configApi((s) => s.config);
  return config ? (
    <MuiThemeProvider theme={orangeThemeLight}>
      <CssBaseline />
      <EmptyLoadingPage absolute />
      <LegacyAuthContext onAuthorized={onAuthorized} onSignOut={onSignOut} logoutUrl={config.homeAppUrl}>
        {children}
      </LegacyAuthContext>
      <Toast api={toastStatus} />
      {idleTimeout && <IdleTimeout />}
      <SuccessContext />
      <NetworkStatus />
    </MuiThemeProvider>
  ) : (
    <EmptyLoadingPage />
    
  );
}
